import React from 'react';
import PropTypes from 'prop-types';
import styles from './BackButton.module.sass';
import ClickableDiv from '../../../ui_kit/clickable_div/ClickableDiv';
import arrowLeft from '../../../../images/pages/quiz/arrow-left.svg';

function BackButton(props) {
  const { decreaseStep } = props;
  return (
    <ClickableDiv className={styles['back-button']} onClick={decreaseStep}>
      <img src={arrowLeft} alt="" />
      Back
    </ClickableDiv>
  );
}

BackButton.propTypes = {
  decreaseStep: PropTypes.func.isRequired,
};

export default BackButton;
